import { motion, AnimatePresence } from 'framer-motion';
import { X, Workflow } from 'lucide-react';

interface ConceptAZModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function ConceptAZModal({ isOpen, onClose }: ConceptAZModalProps) {
  if (!isOpen) return null;

  const steps = [
    { step: 1, name: "Besoins", desc: "Analyser besoins clients" },
    { step: 2, name: "Spécifications", desc: "Bâtir spécifications d'exigences détaillées" },
    { step: 3, name: "Maquette", desc: "Créer maquette avec Overview intégré" },
    { step: 4, name: "Signature", desc: "Signature client + validation" },
    { step: 5, name: "Roadmap", desc: "Roadmap basée sur contrat" },
    { step: 6, name: "Contrat", desc: "Contrat selon cadre Prog & AI" },
    { step: 7, name: "Suivi", desc: "Suivi par quart dans CodeHub" },
    { step: 8, name: "Documentation", desc: "Documentation continue" },
    { step: 9, name: "Révision", desc: "Révision annuelle complète" },
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 overflow-y-auto">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 rounded-2xl max-w-5xl w-full my-8 border border-blue-500/30 shadow-2xl shadow-blue-500/20"
          >
            <div className="relative p-8 border-b border-blue-500/30">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-4">
                  <div className="p-3 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl">
                    <Workflow className="w-10 h-10 text-white" />
                  </div>
                  <div>
                    <h2 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
                      Concept A-Z BZ Prog
                    </h2>
                    <p className="text-gray-400 mt-1 text-lg">
                      Cycle complet de gestion projet - Norme obligatoire tous projets
                    </p>
                  </div>
                </div>
                <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-lg transition-colors">
                  <X className="w-6 h-6 text-gray-400" />
                </button>
              </div>
            </div>

            <div className="p-8 space-y-8 max-h-[calc(100vh-300px)] overflow-y-auto">
              <div className="bg-gradient-to-r from-blue-600/20 via-cyan-600/20 to-blue-600/20 rounded-xl p-8 border-2 border-blue-500/50">
                <h3 className="text-2xl font-bold text-center text-white mb-4">
                  Cycle Complet de Gestion Projet
                </h3>
                <p className="text-gray-300 text-center text-lg">
                  De l'analyse des besoins à la révision annuelle, chaque étape est structurée et documentée.
                </p>
              </div>

              <div className="space-y-4">
                {steps.map((s) => (
                  <div key={s.step} className="flex gap-4 items-start">
                    <div className="w-12 h-12 rounded-full bg-blue-500/20 border-2 border-blue-500 flex items-center justify-center flex-shrink-0">
                      <span className="text-blue-400 font-bold text-xl">{s.step}</span>
                    </div>
                    <div className="bg-gradient-to-br from-blue-500/10 to-cyan-500/10 rounded-xl p-6 border border-blue-500/30 flex-1">
                      <h4 className="text-xl font-bold text-white mb-2">{s.name}</h4>
                      <p className="text-gray-300">{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="p-6 border-t border-blue-500/30 bg-slate-900/50">
              <div className="flex items-center justify-end">
                <button
                  onClick={onClose}
                  className="px-6 py-3 bg-gradient-to-r from-blue-500 to-cyan-500 text-white rounded-xl hover:from-blue-600 hover:to-cyan-600 transition-all duration-200 font-semibold shadow-lg shadow-blue-500/20 hover:shadow-blue-500/40 hover:scale-105"
                >
                  Fermer
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}

